export default val => {
  let text, color;
  if (val == "PAG") {
    text = "Falha na geração de Pagamento";
    color = "#FC4F4F";
  } else if (val == "PAV") {
    text = "Falha na validação de Pagamento";
    color = "#F76E11";
  } else if (val == "PAR") {
    text = "Pagamento cancelado excluído";
    color = "#F76E11";
  } else if (val == "PAC") {
    text = "Falha no cancelamento do Pagamento";
    color = "#F76E11";
  } else if (val == "EBC") {
    text = "Falha ao enviar Boleto";
    color = "#FF9F45";
  } else if (val == "AEE") {
    text = "Erro ao atualizar status empresa";
    color = "#FFBC80";
  } else if (val == "BLE") {
    text = "Bloqueio de empresa";
    color = "#FF6363";
  } else if (val == "ZCC") {
    text = "Erro ao criar empresa no zendesk";
    color = "#ED7D00";
  } else {
    text = "Desconhecido";
    color = "#bfbfbf";
  }
  return { text, color };
};



// WEBPACK FOOTER //
// /src/components/extra/EventTypeText.js